import { GraphUp } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconGraphUp12Line = createIcon(GraphUp, 12, "Line");
export const IconGraphUp16Line = createIcon(GraphUp, 16, "Line");
export const IconGraphUp20Line = createIcon(GraphUp, 20, "Line");
export const IconGraphUp24Line = createIcon(GraphUp, 24, "Line");
export const IconGraphUp32Line = createIcon(GraphUp, 32, "Line");
export const IconGraphUp48Line = createIcon(GraphUp, 48, "Line");
export const IconGraphUp64Line = createIcon(GraphUp, 64, "Line");
